

























































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import TabsComponent from './tabs.vue';
import { alert } from '@/common/modal';
import { Sites, AutoEnrollRules, AutoRegisterRules, InmateSource, Sessions, Courses } from '@lantern/lantern-sdk';
import { DocTypes } from '@lantern/models';
import { CourseListItem, CoursesSelected, Cache } from '@/common/cache';
import { Subscription } from 'vue-rx-decorators';
import { Session } from '@lantern/models';
// @ts-ignore
import Datepicker from 'vuejs-datepicker';

// test del
import { createHash } from 'crypto';
import { timer } from 'node_modules/rxjs';

enum Rules {
    enroll = 'enroll',
    register = 'register'
}

enum CreateDialogModes {
    create = 'create',
    edit = 'edit'
}

interface CreateRuleParams {
    parameters: {
        facilityId: string;
        inmateSource: string;
        siteId?: string;
        has7InchTablet?: boolean;
        courses?: {
            courseId: number;
            sectionId?: number;
        }[];
    };
    isActive: boolean;
    startOn?: Date;
    endOn?: Date;
}
interface RegisterRulesList extends AutoRegisterRules.AutoRegisterRule {
     selected: boolean;
     lastExecuted: string;
     totalProgress: number;
     sesionStatus: SessionRresults;
 }
interface EnrollRulesList extends AutoEnrollRules.AutoEnrollRule {
    selected: boolean;
    lastExecuted: string;
     totalProgress: number;
     sesionStatus: SessionRresults;
}

// For session progress
enum SessionRresults {
    empty = '-',
    completed = 'completed',
    resend = 're-send task',
    seeDetails = 'see details',
    sessionFailed = 'failed',
    sessionPartialFailed = 'completed with errors',
    sessionInProgress = 'processing...',
    sessionCreated = 'Created',
    sessionInProgressErrors = 'processing (has errors)...',

};

interface SessionProgress extends Session.Document {
        sesionStatus: string;
        sessionProgres: string;
        sessionDetails: string;
        sessionResend: string;
        errorAudits: any[];
        sessionTypeString: string;
    }

@Component({
    components: {
        tabs: TabsComponent,
        datepicker: Datepicker
    }
})
export default class RulesComponent extends Vue {
    rule: Rules = Rules.register;
    loader = false;
    dropdown = false;
    courses = false;
    enrollRulesList: EnrollRulesList[] | null = null;
    registerRulesList: RegisterRulesList[] | null = null;

    enroll = Rules.enroll;
    register = Rules.register;
    sites: Sites.Document[] | null = null;

    source = '';
    svis = InmateSource.svis;
    jpay = InmateSource.jpay;
    facility = '';
    modal = {
        create: {
            show: false,
            title: '',
            site: null as Sites.Document | null,
            has7InchTablet: null as boolean| null,
            siteName: '',
            createOpen: this.openCreateDialog,
            cancel: this.createCancel,
            submit: this.createSubmit,
            coursesName: 'Add courses / sections',
            startOn: new Date() as Date | null,
            endOn: null as Date | null,
            mode: CreateDialogModes.create as CreateDialogModes,
            editedRule: null as (RegisterRulesList | EnrollRulesList) | null
        },
        deleteRule: {
            show: false,
            open: this.deleteRuleOpen,
            submit: this.deleteRuleSubmit,
            cancel: this.deleteRuleCancel,
            ruleParameters: null as (RegisterRulesList | EnrollRulesList)[] | null
        },
        parameters: {
            show: false,
            submit: this.parametersSubmit,
            rule: null as EnrollRulesList[] | null
        },
        enroll: {
            show: false,
            cancel: this.enrollCancel,
            submit: this.enrollSubmit,
            create: this.createSection,
            change: this.changeSection
        },
        section: {
            show: false,
            params: {},
            cancel: this.sectionClose,
            submit: this.sectionClose,
        },
        errors: {
            show: false,
            session: null as SessionProgress | null,
            close: this.errorsClose
        }

    };

    Sessionstarted = Session.RequestState.started;
    Sessioncompleted = Session.RequestState.completed;
    sessionEmpty = SessionRresults.empty;
    SessionFailed = SessionRresults.sessionFailed;
    ProgressFiled = SessionRresults.sessionInProgressErrors;
    SessioncompletedErrors = SessionRresults.sessionPartialFailed;

    @Subscription(() => Cache.instance.coursesSelected)
    coursesSelected!: CoursesSelected | {};

    @Subscription(() => Cache.instance.coursesArray)
    coursesArray!: CourseListItem[] | [];

    async created() {
        [this.source, this.facility] = this.$route.params.facilityId.split(':');
        await this.loadSites();
        await this.loadRoules();
    }

    @Watch('rule')
    onisruleChanged() {
        this.loadRoules();
    }

    // #region LOAD DATA
    async loadSites() {
        try {
            const facilityId = this.$route.params.facilityId;
            const query: any = { facilityId, pageSize: 100, pageNumber: 0 };
            const response = await this.$lantern.endpoints.Sites.list(query);
            this.sites = response.data.sites;
        } catch (error: any) {
            await alert(`Site loading error: ${error.message}`);
        }
    }

    async loadRoules() {

        const facilityId = this.$route.params.facilityId;
        const query: any = { facilityId };

        try {
            if (this.rule === this.enroll) {
                const response = await this.$lantern.endpoints.AutoEnrollRules.list(query);
                this.enrollRulesList = await Promise.all(
                    response.data.items.map(async (e) => {
                        // new created rule
                        let lastExecuted = '-';
                        let totalProgress = 0;
                        let sesionStatus = SessionRresults.empty;
                        try {
                            const roleAudit = await this.getLastAudit(e);
                            const fullProgress = this.getProgress(roleAudit.sessions);
                            totalProgress = fullProgress.totalProgress;
                            sesionStatus = fullProgress.sesionStatus;
                            lastExecuted = this.dateFormate(new Date(roleAudit.createdOn).toString(), true);
                        } catch {
                            console.log(`There is no audit for rule: ${e.id}`);
                        }
                        return { ...e, selected: false, lastExecuted, totalProgress, sesionStatus };
                    })
                );

            } else {
                const response = await this.$lantern.endpoints.AutoRegisterRules.list(query);
                this.registerRulesList = await Promise.all(
                    response.data.items.map(async (e) => {
                        // new created rule
                        let lastExecuted = '-';
                        let totalProgress = 0;
                        let sesionStatus = SessionRresults.empty;
                        try {
                            const roleAudit = await this.getLastAudit(e);
                            const fullProgress = this.getProgress(roleAudit.sessions);
                            totalProgress = fullProgress.totalProgress;
                            sesionStatus = fullProgress.sesionStatus;
                            lastExecuted = this.dateFormate(new Date(roleAudit.createdOn).toString(), true);
                        } catch {
                            console.log(`There is no audit for rule: ${e.id}`);
                        }
                        return { ...e, selected: false, lastExecuted, totalProgress, sesionStatus };
                    })
                );

            }

        } catch (error: any) {
            await alert(`Rules loading error: ${error.message}`);
        }
    }

    async getLastAudit(rule: AutoRegisterRules.AutoRegisterRule | AutoEnrollRules.AutoEnrollRule) {
        const lastAudit = await this.$lantern.endpoints.Sessions.lastAuditList({ autoRuleId: rule.id });
        console.log({ lastAudit });
        return lastAudit.data;
    }

    getProgress(sessions: Sessions.Document[]) {

        if (sessions.length === 0) return { totalProgress: 100, sesionStatus: SessionRresults.completed };

        const sessionIndividualProgress = sessions.map(session => {

            // count progress
            const totalTask = session.studentCount + session.registrationCount;
            const totalReady = (session.finishedEnrollment === undefined ? 0 : session.finishedEnrollment) + (session.finishedRegistration === undefined ? 0 : session.finishedRegistration);
            // const ready = Math.ceil((totalReady * 100) / totalTask);
            const ready = (totalReady * 100) / totalTask;

            // status
            let sesionStatus: SessionRresults;
            sesionStatus = SessionRresults.sessionInProgress;
            if (session.requestState === this.Sessioncompleted && !session.hasErrors && ready === 100) {
                sesionStatus = SessionRresults.completed;
            } else if ((session.requestState === this.Sessioncompleted && ready !== 100 && !session.hasErrors) || (session.requestState === this.Sessionstarted && ready !== 0)) {
                sesionStatus = SessionRresults.sessionInProgress;
            } else if ((session.hasErrors && ready === 0) || (session.hasErrors && ready === 100)) {
                sesionStatus = SessionRresults.sessionFailed;
            } else if ((session.hasErrors && ready !== 0 && ready !== 100) || (session.hasErrors && session.requestState === this.Sessionstarted && ready === 100)) {
                sesionStatus = SessionRresults.sessionPartialFailed;
            }

            return { sesionStatus, sessionProgres: ready };
        });

        console.log({ sessionIndividualProgress });

        let totalProgress = 0;
        let allProgress = 0;
        const sessionsTotal = sessionIndividualProgress.length || 1;
        let sesionStatus: SessionRresults = SessionRresults.completed;
        sessionIndividualProgress.map(progress => {
            console.log('progress', progress.sesionStatus);

            allProgress += progress.sessionProgres;
            totalProgress = Math.ceil(allProgress / sessionsTotal);

            //console.log({ totalProgress });

            // if (progress.sesionStatus === SessionRresults.sessionFailed) sesionStatus = SessionRresults.sessionFailed;
            if (totalProgress !== 100) sesionStatus = SessionRresults.sessionInProgress;
            if (progress.sesionStatus === SessionRresults.sessionInProgress && totalProgress !== 100) sesionStatus = SessionRresults.sessionInProgress;
            if ((progress.sesionStatus === SessionRresults.sessionPartialFailed || progress.sesionStatus === SessionRresults.sessionFailed) && totalProgress !== 100) sesionStatus = SessionRresults.sessionInProgressErrors;
            if ((progress.sesionStatus === SessionRresults.sessionPartialFailed || progress.sesionStatus === SessionRresults.sessionFailed) && totalProgress === 100) sesionStatus = SessionRresults.sessionPartialFailed;

            // last few minut on big session
            if ((allProgress / sessionsTotal) < 100 && (allProgress / sessionsTotal) > 99 && progress.sesionStatus === SessionRresults.sessionInProgress) totalProgress = 99;
            return true;
        });

        // refresh numbers if the page is opened
        // console.log({ totalProgress });
        // console.log({ sesionStatus });

        if (totalProgress < 100) {
            console.log(`setTimeout`);
            setTimeout(() => {
                this.loadRoules();
            }, 100000);
        }

        // in case of empty
        return { totalProgress, sesionStatus };

    }
    // #endregion LOAD DATA

    // #region LOAD PARAMETERS FOR ENROLL RULES
    dateFormate(dateString: string, hour?: boolean) {
        if (!dateString) return 'none';
        const date = new Date(dateString);
        const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit', hour: 'numeric', minute: 'numeric', second: 'numeric' });
        const [{ value: month },, { value: day },, { value: year }] = dateTimeFormat.formatToParts(date);

        if (hour) return dateTimeFormat.format(date);
        return `${month}-${day}-${year}`;
    }

    loadParameters(rule: EnrollRulesList[] | null) {
        this.modal.parameters.show = true;
        this.modal.parameters.rule = rule;
    }

    parametersSubmit() {
        this.modal.parameters.show = false;
        this.modal.parameters.rule = null;
    }

    deleteRuleOpen() {
        this.modal.deleteRule.show = true;
        let selectedRules: RegisterRulesList[] | EnrollRulesList[] | null = null;

        if (this.rule === this.enroll) {
            if (this.enrollRulesList) selectedRules = this.enrollRulesList.filter((el: EnrollRulesList) => !!el.selected);
        } else {
            // eslint-disable-next-line no-lonely-if
            if (this.registerRulesList) selectedRules = this.registerRulesList.filter((el: RegisterRulesList) => !!el.selected);
        }
        this.modal.deleteRule.ruleParameters = selectedRules;

        if (this.modal.deleteRule.ruleParameters?.length === 0) {
            alert('Please pick a rule first!');
            this.modal.deleteRule.ruleParameters = null;
            this.modal.deleteRule.show = false;
        };
    }
    // #endregion LOAD PARAMETERS FOR ENROLL RULES

    // #region EDIT RULES
    async changeIsActive(editedRule: (EnrollRulesList | RegisterRulesList)) {
        this.loader = true;

        const editParams = {
            facilityId: editedRule.ruleParameters.facilityId,
            inmateSource: editedRule.ruleParameters.inmateSource,
            isActive: !editedRule.isActive
        };

        try {
            if (this.rule === this.enroll) {
                await this.$lantern.endpoints.AutoEnrollRules.update(editedRule.id, editParams);
                await alert('Updated successfully');
            } else {
                await this.$lantern.endpoints.AutoRegisterRules.update(editedRule.id, editParams);
                await alert('Updated successfully');
            }
        } catch (error) {
            await alert('Error: update failed');
        }
        await this.loadRoules();
        this.loader = false;
    }

    // disabled so far, update only for isActive
    async editRule(editedRule: (EnrollRulesList | RegisterRulesList)) {

        await this.fillUpCreateForm(editedRule);

        this.modal.create.mode = CreateDialogModes.edit;
        this.modal.create.editedRule = editedRule;
        this.modal.create.show = true;

    }

    private async getAllSectionsForCourse(courseId: number): Promise<Courses.Section[]> {
        const pageSize = 50;
        const sections: Courses.Section[] = [];
        const response = await this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber: 1 });
        const lastPage = response.data.pages;
        sections.push(...response.data.items);

        const responseProm: ReturnType<typeof Courses.getSections>[] = [];
        for (let pageNumber = 2; pageNumber <= lastPage; pageNumber++) {
            responseProm.push(this.$lantern.endpoints.Courses.getSections(courseId, { pageSize, pageNumber }));
        }
        await Promise.all(
            await responseProm.map(async req => {
                const resolveCourse = await req;
                return sections.push(...resolveCourse.data.items);
            })
        );
        return sections;
    }

    // disabled so far, update only for isActive
    async fillUpCreateForm(editedRule: (EnrollRulesList | RegisterRulesList)) {
        if (editedRule.ruleParameters.siteId) {
            const site = this.sites?.filter(el => el.id === editedRule.ruleParameters.siteId);
            if (site) {
                this.modal.create.site = site[0];
                this.modal.create.siteName = this.modal.create.site.name;
            }
        }

        if (this.rule === this.enroll) {
            this.modal.create.title = `Edit Enroll rule for ${this.source.toUpperCase()} facility ${this.facility}`;

            if ((editedRule as EnrollRulesList).startOn) this.modal.create.startOn = new Date((editedRule as EnrollRulesList).startOn);
            if ((editedRule as EnrollRulesList).endOn) this.modal.create.endOn = new Date((editedRule as EnrollRulesList).endOn.setHours(23, 59, 59, 999));

            // Get all courses
            this.coursesArray = [];
            try {
                if ((editedRule as any).ruleParameters.courses.length !== 0) {
                    await Promise.all(
                        (editedRule as any).ruleParameters.courses.map(async (el: any) => {
                            const course: any = await this.$lantern.endpoints.Courses.getCourse({ courseId: el.courseId, accountId: (editedRule as any).createdBy.toString() });
                            const list = await this.getAllSectionsForCourse(el.courseId);

                            const sections = list.sort((a, b) => {
                                if (!a.start_at) return 1;
                                if (!b.start_at) return -1;
                                if (new Date(b.start_at).getTime() > new Date(a.start_at).getTime()) return 1;
                                return -1;
                            });
                            const sectionsfiltered = list.filter(section => section.id === el.sectionId);
                            const coursesArrayElement = { ...course.data, selected: true, sections, pickedSection: sectionsfiltered[0] };
                            (this.coursesArray as CourseListItem[]).push(coursesArrayElement);

                            // @ts-ignore
                            this.coursesSelected[`${coursesArrayElement.id}`] = coursesArrayElement;
                        })
                    );

                    this.$cache.coursesArray.next(this.coursesArray);
                    this.$cache.coursesSelected.next(this.coursesSelected);
                }
            } catch (error) {
                await alert('Error: Loading information about courses failed!');
            }

        } else {
            this.modal.create.title = `Edit Register rule for ${this.source.toUpperCase()} facility ${this.facility}`;
        }
    }
    // #endregion EDIT RULES

    // #region DELETE RULE
    deleteRuleCancel() {
        this.modal.deleteRule.ruleParameters = null;
        this.modal.deleteRule.show = false;
    }

    async deleteRuleSubmit() {

        this.modal.deleteRule.show = false;
        if (!this.modal.deleteRule.ruleParameters) return;

        const result = this.deleteAsync(this.modal.deleteRule.ruleParameters);
        try {
            await result;
        } catch (error) {
            await alert(`Error! The rules weren't deleted!`);
        }

        if (await result) await alert(`Rules were deleted!`);
        await this.loadRoules();
    }

    async deleteAsync(rule: (EnrollRulesList | RegisterRulesList)[]): Promise<any> {
        if (this.rule === this.enroll) {
            const result = await Promise.all(rule.map((el: EnrollRulesList | RegisterRulesList) => {
                const parameters: any = {
                    params: {
                        facilityId: this.facility,
                        inmateSource: this.source,
                        id: el.id
                    }
                };
                return this.$lantern.endpoints.AutoEnrollRules.remove(parameters);
            }));
            return result;
        };

        const result = Promise.all(rule.map((el: EnrollRulesList | RegisterRulesList) => {
            const parameters: any = {
                params: {
                    facilityId: this.facility,
                    inmateSource: this.source,
                    id: el.id
                }
            };
            return this.$lantern.endpoints.AutoRegisterRules.remove(parameters);
        }));
        return result;
    }
    // #endregion DELETE RULE

    // #region CREATE RULE
    async openCreateDialog() {
        if (this.rule === this.enroll) {
            this.modal.create.title = `Auto Enroll rule for ${this.source.toUpperCase()} facility ${this.facility}`;
        } else {
            this.modal.create.title = `Auto register rule for ${this.source.toUpperCase()} facility ${this.facility}`;
        };
        this.modal.create.show = true;
        this.modal.create.mode = CreateDialogModes.create;
        this.modal.create.editedRule = null;
    }

    async createSubmit() {

        const registeredParams: CreateRuleParams = {
            parameters: {
                facilityId: this.facility,
                inmateSource: this.source
            },
            isActive: true,
        };

        if (this.rule === this.enroll) {

            if (!this.modal.create.endOn) {
                await alert('Please fill up End On date for the rule');
                return;
            }

            if (!this.modal.create.site) {
                await alert('Please pick a site for the rule');
                return;
            }

            // courses - required field
            if (Object.keys(this.coursesSelected).length === 0) {
                await alert('Please pick a couses first');
                return;
            }
            this.loader = true;

            // add picked courses and sections
            const courses = [];
            for (const course in this.coursesSelected) {
                if (this.coursesSelected.hasOwnProperty(course)) {

                    // if section was set manualy - use it or use default one
                    let sectionId: number;
                    if ((<CoursesSelected> this.coursesSelected)[course].pickedSection) {
                        sectionId = (<CoursesSelected> this.coursesSelected)[course].pickedSection!.id;
                    } else {
                        sectionId = (<CoursesSelected> this.coursesSelected)[course].sections[0].id;
                    }

                    courses.push({ courseId: (this.coursesSelected as any)[course].id, sectionId });
                }
            }
            registeredParams.parameters.courses = courses;

            if (this.modal.create.startOn) registeredParams.startOn = this.modal.create.startOn;
            if (this.modal.create.endOn) registeredParams.endOn = this.modal.create.endOn;
            if (this.modal.create.site) registeredParams.parameters.siteId = this.modal.create.site.id;
            if (this.modal.create.has7InchTablet) registeredParams.parameters.has7InchTablet = this.modal.create.has7InchTablet;

            // Edit - Creat switch
            if (this.modal.create.mode === CreateDialogModes.create) {
                const reponce = await this.$lantern.endpoints.AutoEnrollRules.create(registeredParams);

                // await alert(`Document with id: ${reponce.data.id} was created`);
            } else {
                // disabled, update only for isActive
                // const reponce = await this.$lantern.endpoints.AutoEnrollRules.update(this.modal.create.editedRule!.id, registeredParams);
                // await alert(`Document with id: ${this.modal.create.editedRule!.id} was edited`);
            }

            // clear all courses
            this.$cache.coursesSelected.next({});
            this.modal.create.coursesName = 'Add courses / sections';

        } else {

            if (!this.modal.create.site) {
                await alert('Please pick a site for the rule');
                return;
            }
            this.loader = true;

            if (this.modal.create.site) registeredParams.parameters.siteId = this.modal.create.site.id;
            if (this.modal.create.has7InchTablet) registeredParams.parameters.has7InchTablet = this.modal.create.has7InchTablet!;

            // Edit - Creat switch
            if (this.modal.create.mode === CreateDialogModes.create) {
                const reponce = await this.$lantern.endpoints.AutoRegisterRules.create(registeredParams);

                // await alert(`Document with id: ${reponce.data.id} was created`);
            } else {
                // disabled, update only for isActive
                // const reponce = await this.$lantern.endpoints.AutoRegisterRules.update(this.modal.create.editedRule!.id, registeredParams);
                // await alert(`Document with id: ${reponce.data.id} was created`);
            }
        }

        this.clearCreate();
        await this.loadRoules();
        this.loader = false;
    }

    clearCreate() {

        this.modal.create.show = false;
        this.modal.create.mode = CreateDialogModes.create;
        this.modal.create.editedRule = null;
        this.modal.create.coursesName = '';
        this.modal.create.site = null;
        this.modal.create.siteName = '';
        this.modal.create.startOn = new Date();
        this.modal.create.endOn = null;
        if (this.rule === this.enroll) {
            this.$cache.coursesSelected.next({});
        }
    }

    createCancel() {
        this.clearCreate();
    }

    dropdownClick(site: Sites.Document) {
        this.modal.create.site = site;
        this.dropdown = !this.dropdown;
        this.modal.create.siteName = site.name;
    }
    // #endregion CREATE RULES

    // #region COURSES_LOADER
    async enrollInCourses() {
        this.modal.enroll.show = true;
    }

    async enrollSubmit() {
        this.modal.enroll.show = false;
        this.modal.create.coursesName = 'Courses were added:';
    }

    async enrollCancel() {
        this.modal.enroll.show = false;
    }
    // #endregion COURSES_LOADER

    // #region SECTIONS
    changeSection(course: CourseListItem) {
        this.modal.section.show = true;
        this.modal.section.params = { course, create: false };
    };

    createSection(course: CourseListItem) {
        this.modal.section.show = true;
        this.modal.section.params = { course, create: true };
    }

    sectionClose() {
        this.modal.section.show = false;
    }
    // #endregion SECTIONS

    // #region TEST_BUTTONS
    async testAutoRules() {
        let selectedRules: any | undefined;
        let type: DocTypes;
        if (this.rule === this.enroll) {
            if (this.enrollRulesList) selectedRules = this.enrollRulesList;
            type = DocTypes.AutoEnrollRule;

        } else {
            if (this.registerRulesList) selectedRules = this.registerRulesList;
            type = DocTypes.AutoRegisterRule;
        }

        if (selectedRules) {
            try {
                await Promise.all(
                    selectedRules.map(async (rule: any) => {
                        const inmateSource = this.source === InmateSource.svis ? InmateSource.svis : InmateSource.jpay;
                        await this.$lantern.endpoints.Aws.enqueueAutoRule({ inmateSource, facilityId: rule.ruleParameters.facilityId, id: rule.id, type });
                    })
                );

                setTimeout(() => {
                    this.loadRoules();
                }, 200000);
            } catch {

            }

        }
        await alert('AutoRules were enqueued');
        console.log(selectedRules);
    }

    testShards() {
        const MAX_SHARDS = 10;
        const facilityInmateId = '398733';
        const shasum = createHash('sha1');
        shasum.update(facilityInmateId);
        const shard = shasum.digest().readUInt32LE(0) % MAX_SHARDS;

        const part = `sr:f:svis:I-302805:${shard}`;
    }
    // #endregion TEST_BUTTONS

    // #region FAILED DETAILS
    async getErrorDetails(rule: RegisterRulesList | EnrollRulesList) {

        if (rule.sesionStatus !== this.SessionFailed && rule.sesionStatus !== this.ProgressFiled && rule.sesionStatus !== this.SessioncompletedErrors) return;
        const roleAudit = await this.getLastAudit(rule);
        await this.getFilureDetails(roleAudit.sessions);

    }

    async getFilureDetails(sessions: Sessions.Document[]) {
        await sessions.forEach(async (session) => {
            const progress = await this.$lantern.endpoints.Sessions.getProgress(session.id, { createdOn: session.createdOn });
            this.modal.errors.session = progress.data as any;
            this.modal.errors.show = true;
        });

    }

    errorsClose() {
        this.modal.errors.session = null;
        this.modal.errors.show = false;
    }
    // #endregion FAILED DETAILS

}
